import { useRegisterSW } from 'virtual:pwa-register/react';
import { RefreshCw } from 'lucide-react';
import { Button } from '@shripos/ui';

/**
 * New app version available → let staff reload between customers instead of mid-bill.
 * Checks for updates every 30 minutes while the app is open.
 */
export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      if (registration) setInterval(() => registration.update().catch(() => {}), 30 * 60_000);
    },
  });
  if (!needRefresh) return null;
  return (
    <div className="fixed inset-x-0 bottom-20 z-50 flex justify-center px-4 md:bottom-6">
      <div className="flex items-center gap-3 rounded-xl bg-slate-900 px-4 py-3 text-sm text-white shadow-lg">
        <RefreshCw className="size-4" />
        <span>A new version of ShriPOS is ready.</span>
        <Button size="sm" onClick={() => updateServiceWorker(true)}>
          Reload
        </Button>
        <button className="text-slate-400 hover:text-white" onClick={() => setNeedRefresh(false)}>
          Later
        </button>
      </div>
    </div>
  );
}
